export type Ability = 'view' | 'create' | 'update' | 'delete'
export type Subject = 'activity' | 'admins' | 'broadcasts' | 'candidates' | 'departments' | 'groups' | 'occupations' | 'schedules' | 'shifts' | 'users'

export type Permission = {
    ability: Ability
    subject: Subject
}

export interface SitePermissionJson {
    ability: Ability
    subject: Subject | null
}

export class SitePermission {
    ability: Ability
    subject: Subject | null

    constructor (
        ability: Ability,
        subject: Subject | null,
    ) {
        this.ability = ability
        this.subject = subject
    }

    static fromJson(json: SitePermissionJson): SitePermission {
        return new SitePermission(
            json.ability,
            json.subject,
        )
    }
}
